import { defineStore } from 'pinia';
import CruiseManagement from '@/service/CruiseManagement';

const cruiseManagement = new CruiseManagement();
export const useCruiseManagementStore = defineStore('cruiseManagementStore', {
  state: () => ({}),
  getters: {},
  actions: {
    async getDestinationList() {
      const response = await cruiseManagement.getDestinationList();
      return response;
    },
    async getCruiseLineList() {
      const response = await cruiseManagement.getCruiseLineList();
      return response;
    },
    async getCruiseShipList() {
      const response = await cruiseManagement.getCruiseShipList();
      return response;
    },
    async getSailingList() {
      const response = await cruiseManagement.getSailingList();
      return response;
    },
    async updateStatus(id, payload) {
      const response = await cruiseManagement.updateStatus(id, payload);
      return response;
    }
  }
});
